export const Text = {
  baseStyle: {
    color: 'gray.500',
    fontFamily: 'body'
  }
}
